export const getStudentsForAccountQuery = (accountCode: string, year: string): string => `
query StudentQuery {
    accountSearch(criteria: {accountCode: "${accountCode}", allocation: {year: ${year}}}) {
    content {
      allocation {
        studentNumber
        studentYear {
          registerClass {
            name
            year
            id
            school {
              id
            }
          }
          year
          schoolGrade {
            grade {
              code
              name
            }
          }
        }
        student {
          email {
              adUsername
          }
          color
          imageId
          imageUrl
          gender
          id
          person {
            firstName
            lastName
            nickName
            idNumber
            currentStatusCode
            emailAddresses {
              id
              address
              emailAddressType {
                id
                description
              }
            }
            title {
              description
              shortCode
            }
          }
          medicalAidInfo {
            principleMemberId
            principleMemberIdType
            principleMemberName
            scheme {
              id
            }
            number
          }
          emergencyContact {
            person {
              lastName
              firstName
              emailAddresses {
                id
                address
                emailAddressType {
                  id
                  description
                }
              }
              phoneNumbers {
                id
                number
                phoneNumberType {
                  id
                }
                nationalNumber
                mobileNumber
                countryCode
              }
            }
            relationship {
              id
              description
            }
          }
        }
      }
    }
  }
}
  `;

export const getSimpleGuardianInfoQuery = (id: string): string => `
query SimpleGuardianQuery {
  guardianSearch(criteria: {person: {idNumber: "${id}", accountWithStudents: true}}) {
    content {
      currentStatusCode
      maritalStatus
      employerName
      occupation
      imageId
      imageUrl
      id
      parentalStatus {
        id
        description
      }
      relationship {
        id
        description
      }
      person {
        id
        firstName
        lastName
        nickName
        idNumber
        title {
          description
          id
        }
        addresses {
          postalCode
          region
          streetName
          suburb
          town
          id
          complexErf
          addressType {
            description
            id
            refDataType
            shortCode
          }
        }
        emailAddresses {
          id
          address
          emailAddressType {
            id
            description
          }
        }
        phoneNumbers {
          nationalNumber
          mobileNumber
          id
          number
          phoneNumberType {
            description
            id
          }
          countryCode
        }
      }
      students {
        id
        guardianRole
        accountCode
      }
      linkedAccounts {
        accountHolder
        accountCode
        company {
          companyCode
          id
        }
      }
    }
  }
}
`;

export const getUserAccountInfoQuery = (id: string): string => `
query UserAccountQuery {
  guardianSearch(criteria: {person: {idNumber: "${id}", accountWithStudents: true}}) {
    content {
      active
      currentStatusCode
      maritalStatus
      employerName
      occupation
      imageId
      imageUrl
      id
      parentalStatus {
        id
        description
      }
      students {
        id
        guardianRole
        color
        accountCode
      }
      relationship {
        id
        description
      }
      person {
        firstName
        lastName
        nickName
        idNumber
        title {
          description
          id
        }
        emailAddresses {
          id
          address
          emailAddressType {
            id
            description
          }
        }
        addresses {
          postalCode
          region
          streetName
          suburb
          town
          id
          complexErf
          addressType {
            description
            id
            refDataType
            shortCode
          }
        }
        phoneNumbers {
          nationalNumber
          mobileNumber
          id
          number
          phoneNumberType {
            description
            id
          }
          countryCode
        }
      }
      linkedAccounts {
        accountHolder
        accountCode
        company {
          companyCode
          id
        }
        guardian {
          id
          relationship {
            id
            description
          }
          person {
            firstName
            lastName
            nickName
            idNumber
            emailAddresses {
              id
              address
              emailAddressType {
                id
                description
              }
            }
            phoneNumbers {
              nationalNumber
              mobileNumber
              id
              number
              phoneNumberType {
                description
                id
              }
              countryCode
            }
          }
        }
      }
    }
  }
}
`;
